import type { Tokens } from '../augmentation'
import { spacing } from '../spacing'
import { type ComponentCreation } from './types'

export const createMuiTab = ({ palette, misc }: Pick<Tokens, 'palette' | 'misc'>) =>
  ({
    MuiTab: {
      defaultProps: {
        iconPosition: 'start',
      },
      styleOverrides: {
        root: {
          opacity: 1,
          color: palette.text.primary,
          textTransform: 'none',
          ...misc.createHoverOrActiveState({
            boxShadow: `inset 0px -2px 0px ${palette.text.primary}`,
          }),
          height: spacing(6),
          minHeight: spacing(6),
          minWidth: spacing(11.25),
          maxWidth: spacing(45),
          padding: spacing(1, 2),
          '&.Mui-disabled': {
            color: palette.action.disabled,
          },
        },
      },
    },
  }) satisfies ComponentCreation
